import React, { useRef, useState } from "react";
import EmojiPickerBox from "./EmojiPickerBox";
import AttachMenu from "./AttachMenu";
import ReplyBar from "../messages/ReplyPreview";

function ChatFooter({
  message,
  setMessage,
  onSend,
  onTyping,
  onStopTyping,
  onFileSelect,
  replyTo,
  onCancelReply,
}) {
  const [showEmoji, setShowEmoji] = useState(false);
  const [showAttach, setShowAttach] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
const [previewType, setPreviewType] = useState(null);

  const attachTypeRef = useRef(null);
  const typingTimeoutRef = useRef(null);
  const fileInputRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const [showCamera, setShowCamera] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);

  const mimes = {
    image: "image/*",
    video: "video/*",
    audio: "audio/*",
    file: "*",
  };

  /* ================= VOICE RECORDING LOGIC ================= */
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data.size > 0) audioChunksRef.current.push(e.data);
      };

      mediaRecorderRef.current.onstop = () => {
        const audioBlob = new Blob(audioChunksRef.current, {
          type: "audio/wav",
        });
        const audioFile = new File([audioBlob], `voice_msg_${Date.now()}.wav`, {
          type: "audio/wav",
        });

        if (onFileSelect) onFileSelect(audioFile, "audio");

        stream.getTracks().forEach((track) => track.stop());
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (err) {
      console.error("Error accessing microphone:", err);
      alert("Microphone access denied!");
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    }
  };

const openCamera = async () => {
  try {

    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: false
    });

    streamRef.current = stream;

    setShowCamera(true);

    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
    }, 100);

  } catch (err) {
    console.error("Camera error:", err);
    alert("Camera permission denied");
  }
};

const capturePhoto = () => {

  const video = videoRef.current;
  const canvas = canvasRef.current;

  if (!video || !canvas) return;

  const width = video.videoWidth;
  const height = video.videoHeight;

  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(video, 0, 0, width, height);

  canvas.toBlob((blob) => {

    if (!blob) return;

    const file = new File([blob], `photo_${Date.now()}.jpg`, {
      type: "image/jpeg"
    });

    // SEND FILE
    if (onFileSelect) {
setPreviewFile(file);
setPreviewType("image");    }

    // STOP CAMERA
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
    }

    setShowCamera(false);

  }, "image/jpeg", 0.9);
};




  return (
   <div className="modern-footer">

    {previewFile && (
  <div className="preview-modal">

    <div className="preview-box">

      {previewType === "image" && (
        <img
          src={URL.createObjectURL(previewFile)}
          alt="preview"
          className="preview-media"
        />
      )}

      {previewType === "video" && (
        <video
          controls
          src={URL.createObjectURL(previewFile)}
          className="preview-media"
        />
      )}

      {previewType === "audio" && (
        <audio
          controls
          src={URL.createObjectURL(previewFile)}
        />
      )}

      <div className="preview-actions">

        <button
          className="btn btn-danger"
          onClick={()=>{
            setPreviewFile(null);
            setPreviewType(null);
          }}
        >
          Cancel
        </button>

        <button
          className="btn btn-primary"
          onClick={()=>{
            if(onFileSelect){
              onFileSelect(previewFile, previewType);
            }
            setPreviewFile(null);
            setPreviewType(null);
          }}
        >
          Send
        </button>

      </div>

    </div>

  </div>
)}


{showCamera && (
<div className="camera-modal">

<video
ref={videoRef}
autoPlay
playsInline
muted
className="camera-video"
/>

<canvas ref={canvasRef} style={{display:"none"}}/>

<div className="camera-actions">

<button
className="btn btn-danger"
onClick={()=>{
if(streamRef.current){
streamRef.current.getTracks().forEach(track=>track.stop());
}
setShowCamera(false);
}}
>
Cancel
</button>

<button
className="btn btn-primary"
onClick={capturePhoto}
>
Capture
</button>

</div>

</div>
)}

      {replyTo && (
        <div
          className="reply-preview mb-2 px-3 py-2 rounded"
          style={{
            background: "#f5f6f7",
            borderLeft: "4px solid #0d6efd",
            fontSize: "13px",
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div style={{ maxWidth: "90%" }}>
              <div className="fw-bold text-primary">
                Replying to {replyTo?.senderId?.name || "User"}
              </div>

              <div className="text-muted text-truncate">
                {replyTo?.text || "Message"}
              </div>
            </div>

            <button
              className="btn btn-sm text-muted"
              onClick={onCancelReply}
              style={{ fontSize: "16px" }}
            >
              ✕
            </button>
          </div>
        </div>
      )}

      <div className="position-relative">
        {showEmoji && (
          <div className="emoji-box-wrapper">
            <EmojiPickerBox
              onSelect={(emoji) => {
                setMessage((p) => p + emoji);
                setShowEmoji(false);
              }}
              onClose={() => setShowEmoji(false)}
            />
          </div>
        )}

        {showAttach && (
          <div className="attach-menu-wrapper">
            <AttachMenu
            onPick={(type) => {

  if(type === "camera"){
    openCamera();
    setShowAttach(false);
    return;
  }

  attachTypeRef.current = type;

  if (fileInputRef.current) {
    fileInputRef.current.accept = mimes[type];
    fileInputRef.current.click();
  }

  setShowAttach(false);
}}
            />
          </div>
        )}
      </div>

      <div className="modern-footer-inner">
        <button
          type="button"
          className={`emoji-btn ${showEmoji ? "active" : ""}`}
          onClick={() => {
            setShowEmoji(!showEmoji);
            setShowAttach(false);
          }}
        >
          <span className="emoji-icon">😊</span>
        </button>

        {/* Recording UI Toggle */}
        {isRecording ? (
          <div className="recording-wrapper">
            <div className="recording-box">
              <div className="recording-left">
                <span className="recording-dot"></span>
                <span className="recording-text">Recording...</span>
              </div>

              <button
                type="button"
                className="stop-btn"
                onClick={stopRecording}
              >
                ⏹ Stop
              </button>
            </div>
          </div>
        ) : (
          <input
            type="text"
            className="modern-message-input"
            value={message}
            placeholder="Type a message..."
            onChange={(e) => {
              setMessage(e.target.value);

              if (onTyping) {
                onTyping();
              }

              if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
              }

              typingTimeoutRef.current = setTimeout(() => {
                onStopTyping?.();
              }, 2000);
            }}
            onBlur={() => onStopTyping?.()}
            onKeyDown={(e) => e.key === "Enter" && onSend()}
          />
        )}

        <button
          type="button"
          className="btn btn-light rounded-circle"
          onClick={() => {
            setShowAttach(!showAttach);
            setShowEmoji(false);
          }}
        >
          📎
        </button>

        {message.trim() ? (
          <button
            type="button"
            className="modern-send-btn"
            onClick={onSend}
          >
            ➤
          </button>
        ) : (
          <button
            type="button"
            className="modern-voice-btn"
            onClick={isRecording ? stopRecording : startRecording}
          >
            <svg
              className="mic-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-6 0V4a3 3 0 0 1 3-3z" />
              <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
              <line x1="12" y1="19" x2="12" y2="23" />
              <line x1="8" y1="23" x2="16" y2="23" />
            </svg>
          </button>
        )}
      </div>

      <input
        ref={fileInputRef}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files?.[0];
        if (file) {
  setPreviewFile(file);
  setPreviewType(attachTypeRef.current);
}
          e.target.value = "";
        }}
      />
    </div>
  );
}

export default ChatFooter;
